<template>
    <ies-form-field :field="field">
        <div v-if="formattedDate">{{ formattedDate }}</div>
    </ies-form-field>
</template>

<script>
    /**
     * Shows the date a trip's display status was last changed, sourced from
     * trip_display_updates. That table is one-to-many per trip, so rather
     * than going through the dynamic page's query builder - which cannot
     * express "latest row" for a one-to-many relation - this component
     * fetches its own value directly via AJAX, the same way BlogRegions.vue
     * does for its own has-many-adjacent relation.
     *
     * Read only - nothing here is submitted back with the record.
     */
    export default {
        name: 'ies-input-trip-last-display-change',
        props: ['field', 'recordData', 'page'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                tripKey: 0,
                lastDisplayUpdate: null,
            }
        },

        created: function() {
            this.tripKey = this.getTripKeyFromUrl();
            if (this.tripKey > 0) {
                this.getLastDisplayUpdate();
            }
        },

        computed: {
            formattedDate: function() {
                if (!this.lastDisplayUpdate || !this.lastDisplayUpdate.creation_date) {
                    return null;
                }
                return this.formatDate(this.lastDisplayUpdate.creation_date);
            }
        },

        methods: {
            getTripKeyFromUrl: function() {
                if (!this.page || !this.page.edit_url) {
                    return 0;
                }
                var bits = this.page.edit_url.split('/');
                var foundIndex = null;
                bits.forEach(function(bit, index) {
                    if (bit == '{Trip.trip_key}') {
                        foundIndex = index;
                    }
                });
                if (foundIndex === null) {
                    return 0;
                }
                var urlBits = location.pathname.split('/').splice(1);
                return parseInt(urlBits[foundIndex]) || 0;
            },

            getLastDisplayUpdate: function() {
                axios.get('/api/trip-last-display-update/' + this.tripKey).then((response) => {
                    this.lastDisplayUpdate = response.data.lastDisplayUpdate || null;
                });
            },

            formatDate: function(dateString) {
                var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                var datePart = dateString.split(' ')[0];
                var dateBits = datePart.split('-');
                var year = dateBits[0];
                var month = parseInt(dateBits[1], 10);
                var day = parseInt(dateBits[2], 10);
                return day + ' ' + months[month - 1] + ' ' + year;
            }
        }
    }
</script>
